import React from 'react';
import LastViewedAtProvider from './LastViewedAtProvider';
import NavSidebarProvider from './NavSideBarProvider';
import FavouritesProvider from './FavouritesProvider';
import SavedFiltersUsageLookupProvider from './SavedFiltersUsageLookupProvider';
import SharedProvider from './SharedProvider';
import AvailableWorkSpacesProvider from './AvailableWorkSpacesProvider';
import BonusProgramMetricAssignmentsProvider from './BonusProgramMetricAssignmentsProvider';

const ContentDependantProviders = ({
  children,
}: {
  children: JSX.Element | JSX.Element[];
}) => (
  <LastViewedAtProvider>
    <NavSidebarProvider>
      <FavouritesProvider>
        <SavedFiltersUsageLookupProvider>
          <SharedProvider>
            <AvailableWorkSpacesProvider>
              <BonusProgramMetricAssignmentsProvider>
                {children}
              </BonusProgramMetricAssignmentsProvider>
            </AvailableWorkSpacesProvider>
          </SharedProvider>
        </SavedFiltersUsageLookupProvider>
      </FavouritesProvider>
    </NavSidebarProvider>
  </LastViewedAtProvider>
);

export default ContentDependantProviders;
